"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TimeDisplay: function() {
        return TimeDisplay;
    },
    toTimeString: function() {
        return toTimeString;
    }
});
const _localisationeq1 = require("@equiem/localisation-eq1");
const _luxon = require("luxon");
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const toTimeString = (param)=>{
    let { datetime, timezone, language } = param;
    const date = _luxon.DateTime.fromMillis(datetime, {
        zone: timezone
    });
    return _localisationeq1.formatters.timeshort(date, language);
};
const TimeDisplay = (props)=>/*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, toTimeString(props));

//# sourceMappingURL=TimeDisplay.js.map